
export const mapHistoryMessage = (message, index) => {
  const role = String(message?.role ?? "").toLowerCase();
  const text = String(message?.text ?? "").trim();

  // Ignore malformed or unsupported messages.
  if (!text || !["user", "assistant"].includes(role)) {
    return null;
  }

  const id = String(message.id ?? `history-${role}-${index}`);

  // Preserve the original timestamp only when the API provides one.
  const timestampValue =
    message.timestamp ?? message.created_at ?? message.createdAt;

  const timestamp = timestampValue
    ? new Date(timestampValue)
    : undefined;

 
const commonFields = {
  id,
  isUser: role === "user",
  kind: message.kind ?? "message",
  ...(timestamp && !Number.isNaN(timestamp.getTime())
    ? { timestamp }
    : {}),
};


  if (role === "user") {
    return {
      ...commonFields,
      content: text,
    };
  }

  return {
    ...commonFields,
    conversation_text: text,
    answer: text,
  };
};

export const mapChatHistory = (messages = []) => {
  if (!Array.isArray(messages)) {
    return [];
  }

  return messages
    .map((message, index) => mapHistoryMessage(message, index))
    .filter(Boolean);
};
